module.exports = __webpack_public_path__ + "static/media/ComputerTalk_Step1b_Image4g.b55cd834.jpg";